import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { StyledLabel } from './styled';
const defaultLocalization = {
  optional: 'optional'
};
export const FormControlLabel = _ref => {
  let {
    className,
    localization = defaultLocalization,
    style,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    localization: localization
  }, props));
};